import React from 'react'
import { Table } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import {
  Autocomplete,
  CircularProgress,
  TextField
} from '@mui/material'
import { formatMoney } from '../../../../helpers/utils'
import {
  SPECIAL_PRICE_CREATE_ARIA_LABELS,
  SPECIAL_PRICE_CREATE_AUTOCOMPLETE_SX,
  SPECIAL_PRICE_CREATE_FIELD_LABELS,
  SPECIAL_PRICE_CREATE_MESSAGES,
  SPECIAL_PRICE_CREATE_PRODUCT_TABLE_COLUMNS,
  SPECIAL_PRICE_CREATE_STEP_CONTENT
} from '../specialPriceCreateConstants'

const renderProductTableHeader = () => (
  <thead className="table-header-gray">
    <tr>
      {SPECIAL_PRICE_CREATE_PRODUCT_TABLE_COLUMNS.map((column) => (
        <th key={column.key}>
          <span className="th-header-text">{column.label}</span>
        </th>
      ))}
    </tr>
  </thead>
)

const SpecialPriceProductStep = ({
  fieldErrors,
  fetchProductOptions,
  hasConfiguredDownstreamSteps,
  isProductLoading,
  isScopeStepValid,
  productHasMissingSalesUnit,
  productHasMore,
  productNextPage,
  productOptions,
  productOptionsScopeKey,
  productSearchInput,
  productStepRequiresReconfiguration,
  selectedPackage,
  selectedProduct,
  selectedProductOption,
  onClearProduct,
  onProductInputChange,
  onSelectProduct
}) => {
  return (
    <div className="task-form-section">
      <div className="title-promos-form">
        <b>{SPECIAL_PRICE_CREATE_STEP_CONTENT.product.title}</b>
      </div>
      <p>{SPECIAL_PRICE_CREATE_STEP_CONTENT.product.description}</p>
      <hr className="hr-task-form" />

      <div className="task-form-control-width special-price-create-control-wrap">
        <Autocomplete
          key={productOptionsScopeKey}
          fullWidth
          size="small"
          options={productOptions}
          value={selectedProductOption}
          inputValue={productSearchInput}
          loading={isProductLoading}
          disabled={!isScopeStepValid || Boolean(selectedProduct)}
          onChange={(_event, option) => onSelectProduct(option)}
          onInputChange={onProductInputChange}
          isOptionEqualToValue={(option, value) => option.value === value?.value}
          getOptionLabel={(option) => option?.label || ''}
          filterOptions={(options) => options}
          noOptionsText={
            isProductLoading
              ? SPECIAL_PRICE_CREATE_MESSAGES.productLoading
              : SPECIAL_PRICE_CREATE_MESSAGES.productNoResults
          }
          clearOnBlur={false}
          componentsProps={{
            popper: {
              placement: 'bottom-start',
              modifiers: [
                {
                  name: 'flip',
                  enabled: false
                }
              ]
            }
          }}
          ListboxProps={{
            onScroll: async (event) => {
              const listboxNode = event.currentTarget
              const reachedBottom =
                listboxNode.scrollTop + listboxNode.clientHeight >= listboxNode.scrollHeight - 8

              if (!reachedBottom || !productHasMore || isProductLoading) return

              await fetchProductOptions({
                inputValue: productSearchInput.trim(),
                page: productNextPage,
                append: true
              })
            }
          }}
          sx={SPECIAL_PRICE_CREATE_AUTOCOMPLETE_SX}
          renderInput={(params) => (
            <TextField
              {...params}
              label={SPECIAL_PRICE_CREATE_FIELD_LABELS.productSearch}
              error={Boolean(fieldErrors.product)}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {isProductLoading ? <CircularProgress color="inherit" size={16} /> : null}
                    {params.InputProps.endAdornment}
                  </>
                )
              }}
            />
          )}
        />
      </div>

      {selectedProduct && (
        <div className="mt-20">
          <Table hover responsive>
            {renderProductTableHeader()}
            <tbody>
              <tr>
                <td>{selectedProduct.product_db_ref}</td>
                <td>
                  {selectedProduct.product_id ? (
                    <a
                      className="special-price-link"
                      onClick={() =>
                        window.open(
                          `/productos/${selectedProduct.product_id}/detalles`,
                          '_blank',
                          'noopener,noreferrer'
                        )
                      }
                    >
                      {selectedProduct.product_name}
                    </a>
                  ) : (
                    selectedProduct.product_name
                  )}
                </td>
                <td>{selectedPackage?.unit || '-'}</td>
                <td>{formatMoney(selectedPackage?.price || selectedProduct.base_price)}</td>
                <td>
                  <button
                    type="button"
                    className="delete-report-btn btn-delete-product"
                    onClick={() => onClearProduct(hasConfiguredDownstreamSteps)}
                    aria-label={SPECIAL_PRICE_CREATE_ARIA_LABELS.removeProduct}
                  >
                    <FontAwesomeIcon icon={faTrashAlt} />
                  </button>
                </td>
              </tr>
            </tbody>
          </Table>

          {(fieldErrors.product || productHasMissingSalesUnit) && (
            <div className="invalid-feedback d-block">
              {fieldErrors.product || SPECIAL_PRICE_CREATE_MESSAGES.productMissingSalesUnit}
            </div>
          )}
        </div>
      )}

      {!selectedProduct && productStepRequiresReconfiguration && (
        <div className="mt-20">
          <Table hover responsive>
            {renderProductTableHeader()}
            <tbody>
              <tr>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
              </tr>
            </tbody>
          </Table>
        </div>
      )}
    </div>
  )
}

export default SpecialPriceProductStep
